import React, { useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import SelectTemplates from "./SelectTemplates";
import InlineEditableTitle from "../../core/InlineEditableTitle";
import ProjectService from "../../services/projectServices";

const projectService = new ProjectService();

const ListView = ({ screens, tmplsNFolders, setProject }) => {
  const [updatingScreens, setUpdatingScreens] = useState(new Set());

  const handleTitleSave = async (screenId, newTitle) => {
    setUpdatingScreens((prev) => new Set(prev).add(screenId));

    try {
      await projectService.editScreen({
        id: screenId,
        data: { name: newTitle },
      });

      setProject((prevProject) => ({
        ...prevProject,
        screens: prevProject.screens.map((screen) =>
          screen.id === screenId ? { ...screen, name: newTitle } : screen
        ),
      }));
    } finally {
      setUpdatingScreens((prev) => {
        const updated = new Set(prev);
        updated.delete(screenId);
        return updated;
      });
    }
  };

  return (
    <>
      {screens?.map((screen) => (
        <div key={screen.id} className={"border-bottom"} id={screen.id}>
          <Row
            className={"align-items-start mt-3 project-overview-row project-overview-full-height"}
          >
            <Col xl={4} md={6} className={"mb-5 mb-md-3"}>
              <Card>
                <Card.Body
                  className={"d-flex justify-content-between align-items-center py-2 px-1"}
                >
                  <InlineEditableTitle
                    title={screen.name}
                    onSave={(newTitle) => handleTitleSave(screen.id, newTitle)}
                    placeholder="Screen name"
                    className="mb-0"
                    disabled={updatingScreens.has(screen.id)}
                  />
                </Card.Body>
                <Card.Body className={"p-0"}>
                  <div className={"project-img-box border"}>
                    <Card.Img variant="top" src={screen.imgUrl} alt={""} />
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <SelectTemplates
              screen={screen}
              tmplsNFolders={tmplsNFolders}
              setProject={setProject}
            />
          </Row>
        </div>
      ))}
    </>
  );
};

export default ListView;
